import React, { useContext } from 'react';
import { Store } from '../Store';
import { Alert } from 'reactstrap';

export function UnauthorisedAccessMessage({ children }) {
    const { state: { user } } = useContext(Store);

    const details = user ? `(${ user.tabsusername }) ` : ``;

    return (
        <Alert color="warning">
            <h3>Unauthorised Access</h3>
            <hr />
            <p>Your account { details }doesn&apos;t have access to this section.</p>
            { children }
            <p className={"font-weight-lighter font-italic"}>If your account was recently updated, please log out and log back in to allow the changes to take effect.</p>
        </Alert>
    );
}
